<template>
	<ListingPage />
</template>

<script setup>
import ListingPage from '@/components/product-catalog/ListingPage.vue'

definePageMeta({
	disableGenericCanonical: false,
})
</script>
